import Vue from 'vue'
import urls from '../services.url.js'

export default {
  getRefereeList () {
    let target = urls.REFEREE_URL
    return Vue.http.get(target)
  },
  getStadiumList () {
    let target = urls.STADIUM_URL
    return Vue.http.get(target)
  },
  getSponsorList () {
    let target = urls.SPONSOR_URL
    return Vue.http.get(target)
  },
  getNufflePrayer () {
    let target = urls.NUFFLE_PRAYERS_URL
    return Vue.http.get(target)
  }

}



// WEBPACK FOOTER //
// ./src/api/real-api/ref-datas.api.js